exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".carousel-enter {\n  top: -20px;\n  opacity: 0;\n}\n.carousel-enter.carousel-enter-active {\n  top: 0px;\n  opacity: 1;\n  transition: all 400ms ease-in;\n}\n.carousel-leave {\n  top: 0px;\n  opacity: 1;\n}\n.carousel-leave.carousel-leave-active {\n  top: 0px;\n  opacity: 0;\n  transition: all 300ms;\n}\n.megStyle{\n    display: block;\n    box-sizing: border-box;\n    position: relative;\n    margin-bottom: 10px ;\n    left:50%;\n    text-align:left;\n    word-wrap: break-word;\n    word-break: break-all;\n    resize: none;\n    min-width: 200px;\n    max-width: 30rem;\n    height: auto;\n    font-size: 16px;\n    padding: .5rem 1rem;\n    background-color: rgb(235,248,242);\n    transform: translateX(-50%);\n    border: solid 1px;\n    border-color: rgb(167,225,196);\n    border-radius: 5px;\n    color: rgba(0,0,0,0.65)\n  }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/Components/Toaster/comstyle.css
// module id = 301
// module chunks = 1 2 3 4 5 6